module.exports = __webpack_public_path__ + "img/video.f159a3c2.svg";